'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$() {
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_defaultMake$lzy2 = null;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_defaultMakebitmap$2 = false;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_make$lzy2 = null;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_makebitmap$2 = false;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_given_CanEqual1_Type$lzy2 = null;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_given_CanEqual1_Typebitmap$2 = false;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_CannotParseError$lzy1 = null;
  this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_CannotParseErrorbitmap$1 = false;
}
export { $c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$ as $c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$ };
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$.prototype.constructor = $c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$;
/** @constructor */
function $h_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$() {
}
export { $h_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$ as $h_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$ };
$h_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$.prototype = $c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$.prototype;
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_defaultMakebitmap$2)) {
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_defaultMake$lzy2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_defaultMakebitmap$2 = true;
  }
  return this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_defaultMake$lzy2;
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_makebitmap$2)) {
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_make$lzy2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_makebitmap$2 = true;
  }
  return this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_make$lzy2;
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$.prototype.given_CanEqual1_Type__s_CanEqual = (function() {
  if ((!this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_given_CanEqual1_Typebitmap$2)) {
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_given_CanEqual1_Type$lzy2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_CanEqual$derived$();
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_given_CanEqual1_Typebitmap$2 = true;
  }
  return this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_given_CanEqual1_Type$lzy2;
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$.prototype.CannotParseError__Lframework_data_FrameworkDateTime$Newtype$CannotParseError$ = (function() {
  if ((!this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_CannotParseErrorbitmap$1)) {
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_CannotParseError$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$(this);
    this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_CannotParseErrorbitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$__f_CannotParseError$lzy1;
});
$c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
var $d_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$, "app.data.types_admin$package$AdminAuditLogCreatedAt$", ({
  Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_data_FrameworkDateTime$Newtype: 1,
  Lyantl_Newtype$WithoutValidation: 1
}));
export { $d_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$ as $d_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$ };
var $n_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$;
function $m_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$() {
  if ((!$n_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$)) {
    $n_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$ = new $c_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$();
  }
  return $n_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$;
}
export { $m_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$ as $m_Lapp_data_types\uff3fadmin$package$AdminAuditLogCreatedAt$ };
//# sourceMappingURL=app.data.types_admin$package$-Admin-Audit-Log-Created-At$.js.map
